import "es6-shim";
import * as React from 'react';
import { MyleInstanceClinicSettings, PhoneCheckin } from '../../../dtos/KioskDtos.dtos';
import PhoneNumberValidator, { formatInputAccordingToMask } from '../../../services/Validator/PhoneNumber/PhoneNumberValidator';
import '../../../styles/Buttons.css';
import '../../../styles/Form.css';
import { IGenericsLang, ILabelSelect } from "../../../services/Language/Types";
import { SelectControl } from "../../FormControls/SelectControl";
import { InputControl } from "../../FormControls/InputControl";
import { CheckBoxGroup } from "../../customFormComponents/CheckBoxGroup/CheckBoxGroup";
import { FormContainerInline } from "../../FormControls/FormContainerInline";

interface IPhoneEditProps {
    index: number;
    text: IGenericsLang;
    phone: PhoneCheckin;
    phoneTypesOptions: ILabelSelect[];
    focusedInputName: string;
    countryList: ILabelSelect[];
    defaultCountry: string;
    onPhoneEdit: (phone: PhoneCheckin) => void;
    onDeletePhone: () => void;
    onFocus: (pipe: (value: any) => void, value: any, mask: string, id: string) => void;
    disconnectKeyboard(): void;
    myleClinicSettings: MyleInstanceClinicSettings;
}

export const PhoneEdit = (props: IPhoneEditProps) => {
    const phone = props.phone;
    const [phoneValid, setPhoneValid] = React.useState(PhoneNumberValidator.validatePhoneNumber(props.phone.number, props.phone.countryLookupId || props.defaultCountry));

    React.useEffect(() => setPhoneValid(PhoneNumberValidator.validatePhoneNumber(phone.number, phone.countryLookupId)), [phone.number])

    const onPhoneChange = (change: (phoneState: PhoneCheckin) => void) => {
        const newPhoneState = Object.assign({}, phone);
        change(newPhoneState);
        props.onPhoneEdit(newPhoneState)
    }

    const formatPhoneNumberAccordingToCountryCode = (): string => {
        const mask = PhoneNumberValidator.getPhoneTextMaskByCountry(phone.countryLookupId);
        return formatInputAccordingToMask(phone.number, mask);
    }

    const onExtensionChange = (value: string) => {
        if (value.length <= 7) {
            const newState = Object.assign({}, phone);
            newState.extension = value.substring(0, 7);
            props.onPhoneEdit(newState);
        }
    }
    const textString = props.text;

    const phoneCountrySelectRender = () => (
        <SelectControl
            onFocus={props.disconnectKeyboard}
            placeholder={textString.labels.CountryLabel}
            onChange={(country: string) => onPhoneChange(phoneObject => phoneObject.countryLookupId = country)}
            value={phone.countryLookupId}
            options={props.countryList}
        />
    )

    const phoneTypeSelectRender = () => (
        <SelectControl
            placeholder={textString.labels.TypeLabel}
            onChange={(value: string) => onPhoneChange(phoneObject => {
                phoneObject.phoneType = value.split('-')[1];
                phoneObject.contactPointType = value.split('-')[0];
                phoneObject.extension = "";
                if (props.myleClinicSettings.enablePatientNotifiableContactPoints && phoneObject.phoneType !== "Mobile") 
                    phoneObject.notificationsEnabled = false;
            })}
            value={phone.contactPointType + "-" + phone.phoneType}
            options={props.phoneTypesOptions}
            onFocus={props.disconnectKeyboard}
        />
    )

    const phoneNumberInputRender = () => (
        <InputControl
            placeHolder={textString.labels.PhoneLabel}
            onChange={(val) => onPhoneChange(phoneState => phoneState.number = val)}
            isValid={phoneValid}
            value={formatPhoneNumberAccordingToCountryCode()}
            onFocus={() => props.onFocus((val) => onPhoneChange(phoneObject => phoneObject.number = val), phone.number, "1111111111", "phoneNumber" + props.index)}
            focused={props.focusedInputName === ("phoneNumber" + props.index)}
        />
    )

    const extensionRender = () => (
        phone.phoneType.includes('Phone')
            ? (
                <div>
                    <InputControl
                        placeHolder={textString.labels.PhoneExtensionLabel}
                        value={phone.extension}
                        required={false}
                        onChange={onExtensionChange}
                        onFocus={() => props.onFocus(onExtensionChange, phone.extension, "1111111", "extension" + props.index)}
                        focused={props.focusedInputName === ("extension" + props.index)}
                    />
                </div>
            )
            : null
    )

    const isPreferredRender = () => {
        const preferredId = "preferredPhone";
        const notificationsId = "phoneNotifications";

        const options = [{ label: textString.labels.PreferredPhoneLabel, checked: phone.isPreferred, disabled: false, optionId: preferredId }];

        if (props.myleClinicSettings.enablePatientNotifiableContactPoints && phone.phoneType === "Mobile")
            options.push({ label: textString.labels.NotificationsLabel, checked: phone.notificationsEnabled, disabled: false, optionId: notificationsId });
      
        return <div style={{ fontSize: "30px" }}>
            <CheckBoxGroup
                componentId="phoneNotificationsAndPreferredContainer"
                options={options}
                inline
                onChange={(checked: boolean, id: string) => onPhoneChange(newState => {
                    if (id === preferredId)
                        newState.isPreferred = checked;
                    else if (id === notificationsId)
                        newState.notificationsEnabled = checked;
                })}
            />
        </div>
    }

    return (
        <div className="col-sm-12">
            <FormContainerInline
                onDelete={props.onDeletePhone}
                elements={[
                    phoneCountrySelectRender(),
                    phoneTypeSelectRender(),
                    phoneNumberInputRender(),
                    extensionRender(),
                    isPreferredRender()
                ]}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/PatientOverview/EditComponents/PhoneEdit.tsx